<template>
  <div class="tree-selector-demo">
    <h1>树形选择器演示</h1>
    <p>点击节点进行选择，必须按照从上到下的层级顺序选择</p>
    
    <TreeSelector @confirm="handleConfirm" ref="treeSelector" />
    
    <div class="result" v-if="result">
      <h3>选择结果：</h3>
      <p><strong>路径：</strong>{{ result.path }}</p>
      <p><strong>节点详情：</strong></p>
      <ul>
        <li v-for="node in result.nodes" :key="node.id">
          {{ node.text }} (层级: {{ node.level }})
        </li>
      </ul>
    </div>
    
    <el-button @click="resetSelection" type="warning" style="margin-top: 20px;">
      重置选择
    </el-button>
  </div>
</template>

<script>
import TreeSelector from '@/components/TreeSelector.vue'

export default {
  name: 'TreeSelectorDemo',
  components: {
    TreeSelector
  },
  data() {
    return {
      result: null
    }
  },
  methods: {
    handleConfirm(data) {
      this.result = data
      console.log('选择结果:', data)
    },
    
    resetSelection() {
      this.result = null
      this.$refs.treeSelector.reset()
    }
  }
}
</script>

<style scoped>
.tree-selector-demo {
  padding: 40px;
  max-width: 1200px;
  margin: 0 auto;
}

h1 {
  text-align: center;
  color: #333;
  margin-bottom: 10px;
}

p {
  text-align: center;
  color: #666;
  margin-bottom: 30px;
}

.result {
  margin-top: 30px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #67C23A;
}

.result h3 {
  margin-top: 0;
  color: #333;
}

.result ul {
  margin: 10px 0;
  padding-left: 20px;
}

.result li {
  margin: 5px 0;
  color: #666;
}
</style>